import { Outlet } from "react-router-dom";
import { WebSocketProvider } from "../WebSocketContext";

const ProtectedLayout = () => {
  return (
    <WebSocketProvider>
      <Outlet />
    </WebSocketProvider>
  );
};

export default ProtectedLayout;
